import { useSyncExternalStore } from 'react'
import type { ScreenStateX } from '../../../types/mfc'
import { pubSub } from '../../app-state/pubSub'
import { getScreenState } from '../../app-state/state.screen'

const subScreenOrientation = (cb) => pubSub.SCREEN.on('state', cb)
const getScreenStateSelector =
    <T extends keyof ScreenStateX>(
        attribute: T,
        defaultValue?: ScreenStateX[T],
    ) =>
    () =>
        getScreenState()[attribute] ?? defaultValue

export const useScreenStateSelector = <T extends keyof ScreenStateX>(
    attribute: T,
    defaultValue?: ScreenStateX[T],
): ScreenStateX[T] => {
    return useSyncExternalStore(
        subScreenOrientation,
        getScreenStateSelector(attribute, defaultValue),
        getScreenStateSelector(attribute, defaultValue),
    )
}
